import createReducer from '../createReducer';
import {
  CLEAR_SUBREGION_OVERVIEW_DATA,
  FETCH_SUBREGION_OVERVIEW_DATA,
  FETCH_SUBREGION_OVERVIEW_DATA_SUCCESS,
} from '../../actions/subregion';
import { LEAVE_SPOT_ROUTE } from '../../actions/routes';

const initialState = {
  subregionId: '',
  associated: {
    chartsUrl: null,
    units: {
      waveHeight: null,
    },
  },
  overview: {
    data: null,
  },
  loading: false,
};

const handlers = {};

handlers[CLEAR_SUBREGION_OVERVIEW_DATA] = () => ({
  ...initialState,
});

handlers[FETCH_SUBREGION_OVERVIEW_DATA] = (state, { subregionId }) => ({
  ...state,
  subregionId,
  loading: true,
});

handlers[FETCH_SUBREGION_OVERVIEW_DATA_SUCCESS] = (state, { overview }) => ({
  ...state,
  associated: overview.associated,
  overview,
  loading: false,
});

handlers[LEAVE_SPOT_ROUTE] = () => initialState;

export default createReducer(handlers, initialState);



// WEBPACK FOOTER //
// ./src/reducers/subregion/overview.js